define("shared/helpers/to-fixed", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * Applies a given number of decimals to the provided number.
   *
   * @method to-fixed
   * @param {Number} params[0] A value to check if it needs toFixed applied
   * @param {Number} decimals Number of decimals to fix the number params[0] to
   *
   * @return {String} Formatted price for display
   */
  var _default = _exports.default = (0, _helper.helper)((params, _ref) => {
    let {
      decimals
    } = _ref;
    const isDecimal = params[0] % 1 !== 0;
    if (typeof params[0] !== 'number' || params[0] === '') {
      return '';
    }
    if (params[0] === 0) {
      return params[0];
    }
    if (isDecimal && decimals) {
      return params[0].toFixed(decimals);
    }
    return params[0];
  });
});